import { Button, Col, Form, Input, Row } from 'antd';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import SignatureVerificationModal from './modals/SignatureVerificationModal';
import SignaturePadComponent from './SignaturePadComponent';
import { IMAGE_BASE_URL } from '../../common/Constants';
import { ServerAPI } from '../../common/ServerAPI';
import SignRemotely from './modals/SignRemotely';
import PageLoader from '../../components/PageLoader';

const EditSignatureUpload = ({ updateFunction, type, activeGuarantor }) => {
    const [signatureUpload, setSignatureUpload] = useState(false);
    const [remoteSignature, setRemoteSignature] = useState(false);
    const [signatureHolderId, setSignatureHolderId] = useState('');
    const [loanDetails, setLoanDetails] = useState({});
    const [applicantsignatureDataUrl, setApplicantSignatureDataUrl] = useState(null);
    const [signatureHolder, setSignatureHolder] = useState("");
    const [signatureHolderName, setSignatureHolderName] = useState("");
    const [guarantorIndex, setGuarntorIndex] = useState(0);
    const [signatureValidator, setSignatureValidator] = useState(false);
    const [applicantType, setApplicantType] = useState('');
    const [guarantorType, setGuarantorType] = useState('');
    const [guarantor, setGuarantor] = useState(null);

    const handleSaveSignature = async (dataUrl, stampUrl) => {
        let updateLoanDetails = { ...loanDetails };
        if (signatureHolder == 'applicant') {
            if (updateLoanDetails['applicant_documents']) {
                updateLoanDetails['applicant_documents']['applicant_signature'] = dataUrl;
                updateLoanDetails['applicant_documents']['company_stamp'] = stampUrl;
            } else {
                updateLoanDetails['applicant_documents'] = {
                    'nric': [],
                    'nao': [],
                    'cpf': [],
                    'driving_license': [],
                    'additional_documents': [],
                    'applicant_signature': dataUrl,
                    'company_stamp': stampUrl
                }
            }
            let savedValues = localStorage.getItem('applicant_documents');
            const parsedValues = savedValues ? JSON.parse(savedValues) : {};
            parsedValues['applicant_signature'] = {
                'name': 'applicantSignature',
                "value": dataUrl
            }
            parsedValues['company_stamp'] = {
                'name': 'companyStamp',
                "value": stampUrl
            }
            localStorage.setItem('applicant_documents', JSON.stringify(parsedValues));
            setLoanDetails(updateLoanDetails);
            const response = await ServerAPI.updateApplication("signature", updateLoanDetails);
        } else {
            if (updateLoanDetails['guarantor_details'][guarantorIndex]['documents']) {
                updateLoanDetails['guarantor_details'][guarantorIndex]['documents']['guarantor_signature'] = dataUrl;
                updateLoanDetails['guarantor_details'][guarantorIndex]['documents']['company_stamp'] = stampUrl;
            } else {
                updateLoanDetails['guarantor_details'][guarantorIndex]['documents'] = {
                    'nric': [],
                    'nao': [],
                    'cpf': [],
                    'driving_license': [],
                    'additional_documents': [],
                    'bank_statement': [],
                    'guarantor_signature': dataUrl,
                    'company_stamp': stampUrl
                };

            }

            setLoanDetails(updateLoanDetails);
            let savedValues = localStorage.getItem('guarantor_sign_documents_' + guarantorIndex);
            const parsedValues = savedValues ? JSON.parse(savedValues) : {};
            parsedValues['guarantor_signature'] = {
                'name': 'guarantorSignature',
                "value": dataUrl
            }
            parsedValues['company_stamp'] = {
                'name': 'companyStamp',
                "value": stampUrl
            }

            localStorage.setItem('guarantor_sign_documents_' + guarantorIndex, JSON.stringify(parsedValues));
            const response = await ServerAPI.updateApplication("signature", updateLoanDetails);
            getLoanDetails();
            updateFunction();
        }
    };

    const getLoanDetails = async () => {
        const response = await ServerAPI.getApplication();
        if (response) {
            setLoanDetails(response.data);
            setGuarantor(response?.data?.guarantor_details[activeGuarantor]);
            let savedValues = localStorage.getItem('applicant_documents');
            const parsedValues = savedValues ? JSON.parse(savedValues) : {};
            parsedValues['applicant_signature'] = {
                'name': 'applicantSignature',
                "value": response.data['applicant_documents']['applicant_signature'],
            }
            parsedValues['company_stamp'] = {
                'name': 'companyStamp',
                "value": response.data['applicant_documents']['company_stamp']
            }
            localStorage.setItem('applicant_documents', JSON.stringify(parsedValues));

            let Guarantors = response.data['guarantor_details'];
            if (Guarantors && Guarantors.length > 0) {
                Guarantors.map((guarantor, idx) => {
                    let guarantor_index = idx + 1;
                    let savedValues = localStorage.getItem('guarantor_sign_documents_' + guarantor_index);
                    const parsedValues = savedValues ? JSON.parse(savedValues) : {};
                    parsedValues['guarantor_signature'] = {
                        'name': 'guarantorSignature',
                        "value": guarantor['documents']?.['guarantor_signature'],
                    }
                    parsedValues['company_stamp'] = {
                        'name': 'companyStamp',
                        "value": guarantor['documents']?.['company_stamp']
                    }
                    // localStorage.setItem('guarantor_sign_documents_' + guarantor_index, JSON.stringify(parsedValues));
                })
            }


        }
    }

    useEffect(() => {
        let applicantTypeData = localStorage.getItem('applicanttype');
        if (applicantTypeData) {
            setApplicantType(applicantTypeData);
        }
        getLoanDetails();
    }, [activeGuarantor])

    useEffect(() => {
        let validationApplicantResult = false;
        let validationGuarantorResult = false;
        if (loanDetails.applicant_documents?.['applicant_signature'] != '' && loanDetails.applicant_documents?.['applicant_signature'] != "fileurl") {
            validationApplicantResult = true;
        }
        if (loanDetails.guarantor_details && loanDetails.guarantor_details.length > 0) {
            loanDetails.guarantor_details.map((guarantor) => {
                if (guarantor.documents?.guarantor_signature != '') {
                    validationGuarantorResult = true;
                } else {
                    validationGuarantorResult = false;
                    return;
                }
            })
        } else {
            validationGuarantorResult = true;
        }
        if (validationApplicantResult == true && validationGuarantorResult == true) {
            updateFunction(true);
        } else {
            updateFunction(false);
        }
    }, [loanDetails])

    useEffect(() => {
        if (signatureValidator == true) {

        }

    }, [signatureValidator])
    if (!guarantor) {
        return (
            <PageLoader />
        )
    }

    return (
        <div className='mx-5'>
            {
                type === 'guarantor' && (
                    <div className="flex flex-wrap rounded-lg border border-search-border-color p-3 flex justify-between tst1 my-4 mb-[30px]">
                        <Fragment>
                            <Row gutter={[24, 24]}>
                                <Col xs={24} sm={24} md={24} lg={24}>
                                    <Row>
                                        <div className='mt-1'>
                                            {guarantor?.documents?.guarantor_signature != '' ?
                                                <img className='mt-[3px]' src='/images/tick.png' />
                                                :
                                                <img className='' src='/images/wrong.png' />
                                            }
                                        </div>
                                        <div className='ml-1'>
                                            <div className='text-[13px] font-[500] w-[100px] p-1'>Guarantor {activeGuarantor + 1}</div>
                                            <div className='text-[13px] font-[700] ml-[2px]'>{guarantor?.personal_details?.name ? guarantor?.personal_details?.name : guarantor.personal_details?.company_name}</div>
                                            <div className='text-[12px] font-[400] ml-[2px]'>{guarantor?.personal_details?.nric ? guarantor?.personal_details?.nric : guarantor?.personal_details?.uen_acra_no}</div>
                                        </div>
                                    </Row>
                                </Col>
                                <Col xs={24} sm={12} md={24} lg={24}>
                                    <div className='mt-[-20px]'>
                                        <Row gutter={[16, 16]}>
                                            <Col xs={12} sm={6} md={6} lg={6}>
                                                <label className='form-field-label'>Person is present? </label>
                                                <Button onClick={(e) => {
                                                    e.preventDefault();
                                                    setSignatureHolder("guarantor");
                                                    setGuarntorIndex(activeGuarantor);
                                                    setSignatureUpload(true);
                                                    setGuarantorType(guarantor.guarantor_type);
                                                }} type="primary" className="w-[105px] p-[6px_10px]  text-[12px]  font-lato">Sign Now</Button>
                                            </Col>
                                            <Col xs={12} sm={6} md={6} lg={6}>
                                                <label className='form-field-label'>Person is away? </label>
                                                <Button onClick={(e) => {
                                                    setRemoteSignature(true);
                                                    setSignatureHolder("guarantor");
                                                    setSignatureHolderId(guarantor?.id);
                                                    setGuarntorIndex(activeGuarantor);
                                                    setSignatureHolderName(guarantor?.personal_details?.name ? guarantor?.personal_details?.name : guarantor?.personal_details?.company_name);
                                                    setGuarantorType(guarantor?.guarantor_type);
                                                }} className="wh w-[105px] p-[6px_10px] text-[12px] font-lato">Sign Remotely</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} md={24} lg={24}>
                                    <div className='mr-[-22px] mt-5'>
                                        <div className='text-right view-svg'>
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="Group 9112">
                                                    <g id="Ellipse 205" filter="url(#filter0_d_1356_7707)">
                                                        <circle cx="12.5" cy="12.5" r="10.5" fill="#0660FC" />
                                                    </g>
                                                    <g id="Group 9111">
                                                        <circle id="Ellipse 46" cx="11.6866" cy="10.0206" r="3.35259" fill="white" />
                                                        <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M12.8948 14.1423C12.7976 14.3546 12.7503 14.6099 12.7536 14.9848C12.7609 15.8146 13.0293 16.0776 13.5659 16.6037C14.0993 17.1266 14.7874 17.6411 15.5941 17.8944C12.5952 18.3664 9.53214 18.292 6.55353 17.6713C6.18286 17.594 5.9621 17.2062 6.14629 16.8753C6.55234 16.146 7.19203 15.5052 8.01036 15.0168C9.06428 14.3878 10.3556 14.0469 11.684 14.0469C12.0931 14.0469 12.4986 14.0792 12.8948 14.1423Z" fill="white" />
                                                        <path id="Subtract_2" fillRule="evenodd" clipRule="evenodd" d="M13.6726 14.1918C14.2052 13.4899 15.1662 12.6074 16.6313 12.6074C18.0965 12.6074 19.0575 13.4899 19.5901 14.1918C19.8292 14.5069 19.9487 14.6644 19.94 15.0147C19.9312 15.365 19.7962 15.5257 19.526 15.8471C18.9307 16.5552 17.9121 17.473 16.6313 17.473C15.3505 17.473 14.332 16.5552 13.7367 15.8471C13.4665 15.5257 13.3315 15.365 13.3227 15.0147C13.314 14.6644 13.4335 14.5069 13.6726 14.1918ZM16.6317 16.4296C17.3995 16.4296 18.0219 15.8072 18.0219 15.0394C18.0219 14.2716 17.3995 13.6492 16.6317 13.6492C15.864 13.6492 15.2416 14.2716 15.2416 15.0394C15.2416 15.8072 15.864 16.4296 16.6317 16.4296Z" fill="white" />
                                                    </g>
                                                </g>
                                                <defs>
                                                    <filter id="filter0_d_1356_7707" x="0" y="0" width="25" height="25" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                                                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                                                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                                                        <feOffset />
                                                        <feGaussianBlur stdDeviation="1" />
                                                        <feComposite in2="hardAlpha" operator="out" />
                                                        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
                                                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1356_7707" />
                                                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1356_7707" result="shape" />
                                                    </filter>
                                                </defs>
                                            </svg>
                                        </div>
                                    </div>
                                </Col>
                                <Col>
                                    <div className='text-[12px] font-[500] text-instruction-grey signature-text mb-2 mt-2'>Stored Signature/Company Stamp</div>
                                    <div className='flex'>
                                        {guarantor?.documents?.guarantor_signature ?
                                            <img className='w-[140px] h-[72px] border rounded-lg applicant' src={guarantor?.documents?.guarantor_signature && IMAGE_BASE_URL + "/" + guarantor?.documents?.guarantor_signature} />
                                            :
                                            <span className="ml-[10px] h-[72px] w-[140px] border border-rounded-[10px] rounded-lg alt-text">N/A</span>
                                        }
                                        {guarantor?.documents?.company_stamp ?
                                            <img className='ml-[10px] w-[70px] h-[72px] border border-rounded-[10px] rounded-lg' src={guarantor?.documents?.company_stamp && IMAGE_BASE_URL + "/" + guarantor?.documents?.company_stamp} />
                                            :
                                            <span className="ml-[10px] h-[72px] w-[70px] border border-rounded-[10px] rounded-lg alt-text">N/A</span>
                                        }
                                    </div>
                                </Col>
                            </Row>
                        </Fragment>
                    </div>
                )
            }
            <SignaturePadComponent
                visible={signatureUpload}
                onCancel={() => { setSignatureUpload(false) }}
                onSave={handleSaveSignature}
                signatureHolder={signatureHolder}
                holderType={guarantorType}
            />
            <SignRemotely open={remoteSignature} close={() => { setRemoteSignature(false) }} applicationId={localStorage.getItem('applicationno')} holderId={signatureHolderId} holderType={signatureHolder} name={signatureHolderName} index={guarantorIndex} />
        </div >
    );
};

export default EditSignatureUpload;
